module.exports = __webpack_public_path__ + "static/id_card_notify.79182aee.png";